<section class="fixed-top" [class.compact]="compactHeader">
  <!-- top banner nav -->
  <div
    class="container-fluid top-label bg-white position-relative d-lg-block d-none"
  >
    <div class="flexBetween">
      <!-- Logo Section -->
      <div routerLink="">
        <img
          [src]="logo"
          alt="uncover egypt tour Logo"
          title="uncover egypt tour Logo"
          class="me-2"
          style="width: 140px; height: 50px; object-fit: contain"
        />
        <span class="border-start ps-3">Your passport to adventure</span>
      </div>

      <div class="info pe-5">
        <div class="text-capitalize">
          <a routerLink="/about">about us</a> |
          <a routerLink="/contact">contact us</a> |
          <a routerLink="/blog">blog</a>
        </div>
        <h6 class="mb-1">For help and expert advice:</h6>
        <h5>
          <a href="tel:{{ phoneNunmber }}">{{ phoneNunmber }}</a>
        </h5>
      </div>
    </div>

    <div
      class="signBtn bgMainColor text-white position-absolute top-0 end-0 d-flex align-items-center"
    >
      <i routerLink="/signup" role="button" class="fa fa-circle-user"></i>
    </div>
  </div>

  <!-- Main Navbar -->
  <nav
    class="navbar navbar-expand-lg text-white bg-dark shadow"
    [class.sidebar-open]="isSidebarOpen"
  >
    <div class="container-fluid">
      <!-- Logo Section -->
      <div routerLink="" class="navbar-brand d-lg-none me-0">
        <img
          [src]="logo"
          alt="uncover egypt tour Logo"
          title="uncover egypt tour Logo"
          class="me-2"
          style="width: 140px; height: 50px; object-fit: contain"
        />
      </div>
      <!-- Navigation Links (Desktop) -->
      <div class="navbar-nav me-auto d-none d-lg-flex text-capitalize">
        <ng-container *ngFor="let link of navigationLinks">
          <!-- main link 'home , about , blog , contact' -->
          <a
            [routerLink]="link.path"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: link.path === '/' }"
            class="nav-link px-2 mx-2 fw-medium text-white position-relative"
          >
            {{ link.label }}
          </a>

          <!-- after Home (/) render Tours dropdown + Diving + Destinations -->
          <ng-container *ngIf="link.path === '/' && allCategories.length">
            <!-- Tours dropdown -->
            <div
              class="nav-link px-2 mx-2 fw-medium text-white position-relative dropdown custom-dropdown"
            >
              <span routerLink="/tour" class="d-block text-capitalize cPointer"
                >tours</span
              >
              <ul class="dropdown-menu border-0 shadow">
                <li *ngFor="let cat of allCategories">
                  <a
                    class="dropdown-item"
                    [routerLink]="['/tour']"
                    [queryParams]="{ type: cat.id }"
                  >
                    {{ cat.title }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- Diving category link -->
            @for (cat of allCategories; track cat.id) {
              @if ((cat.title || "").trim().toLowerCase() === "diving") {
                <a
                  [routerLink]="['/tour']"
                  [queryParams]="{ type: cat.id }"
                  class="nav-link px-2 mx-2 fw-medium text-white position-relative"
                  routerLinkActive="active"
                >
                  {{ cat.title }}
                </a>
              }
            }

            <!-- Destinations dropdown -->
            <ng-container *ngIf="allDestinations.length">
              <div
                class="nav-link px-2 mx-2 fw-medium text-white position-relative dropdown custom-dropdown"
              >
                <span routerLink="/destination" class="d-block cPointer"
                  >Destinations</span
                >
                <ul class="dropdown-menu border-0 shadow">
                  <li *ngFor="let dest of allDestinations">
                    <a
                      class="dropdown-item"
                      [routerLink]="['/destination', dest.slug]"
                    >
                      {{ dest.title }}
                    </a>
                  </li>
                </ul>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>

      <!-- Right Section -->
      <div class="d-flex align-items-center flex-nowrap gap-3">
        <div>
          <a title="Call me" href="tel:{{ phoneNunmber }}">
            <i class="fa fa-phone textMainColor me-2 fw-bold cPointer"></i
          ></a>

          <i
            routerLink="/signup"
            class="fa fa-circle-user textMainColor me-2 fw-bold cPointer"
            title="Tours sign up"
          ></i>
          <i
            routerLink="/cart"
            routerLinkActive="textSecondColor"
            class="fa fa-cart-plus textMainColor me-2 fw-bold cPointer"
            title="Tours cart"
          ></i>

          <i
            routerLink="/profile"
            routerLinkActive="textSecondColor"
            class="fa fa-address-book textMainColor me-2 fw-bold cPointer"
            title="My profile"
          ></i>
        </div>

        <!-- make trip Button -->
        <button
          routerLink="/makeTrip"
          class="mainBtn Btn d-none d-lg-flex align-items-center gap-2"
        >
          make trip
          <i
            class="fas fa-plane-up fa-rotate-by bgPrimaryWhiteColor rounded-circle overflow-hidden"
          ></i>
        </button>

        <!-- Toggle Button -->
        <button
          class="secBtn Btn rounded-2 d-lg-none"
          (click)="toggleSidebar()"
          type="button"
          aria-label="Toggle navigation"
        >
          <span class="fa fa-bars fs-5 border-0"></span>
        </button>
      </div>
    </div>
  </nav>
</section>
<!-- spacer so content isn't hidden under fixed header -->
<div class="header-spacer"></div>

<!-- Sidebar -->
<div
  class="offcanvas offcanvas-end"
  id="sidebarOffcanvas"
  tabindex="-1"
  aria-labelledby="sidebarOffcanvasLabel"
  [class.show]="isSidebarOpen"
  [style.visibility]="isSidebarOpen ? 'visible' : 'hidden'"
>
  <div class="offcanvas-header border-bottom">
    <div class="d-flex align-items-center">
      <img
        [src]="logo"
        alt="uncover egypt tour Logo"
        class="me-2"
        style="width: 140px; height: 50px; object-fit: contain"
      />
    </div>
    <button
      class="btn-close"
      (click)="closeSidebar()"
      type="button"
      aria-label="Close"
    ></button>
  </div>

  <div class="offcanvas-body">
    <div class="navbar-nav flex-column">
      <ng-container *ngFor="let link of navigationLinks">
        <!-- main link 'home , about , blog , contact' -->
        <a
          [routerLink]="link.path"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: link.path === '/' }"
          class="nav-link px-2 mx-2 fw-medium text-dark position-relative"
        >
          {{ link.label }}
        </a>

        <!-- after Home (/) render Tours dropdown + Diving + Destinations -->
        <ng-container *ngIf="link.path === '/' && allCategories.length">
          <!-- Tours dropdown -->
          <div
            class="nav-link px-2 mx-2 fw-medium text-dark position-relative dropdown custom-dropdown"
          >
            <span routerLink="/tour" class="d-block text-capitalize cPointer"
              >tours</span
            >
            <ul class="dropdown-menu border-0 shadow">
              <li *ngFor="let cat of allCategories">
                <a
                  class="dropdown-item"
                  [routerLink]="['/tour']"
                  [queryParams]="{ type: cat.id }"
                >
                  {{ cat.title }}
                </a>
              </li>
            </ul>
          </div>

          <!-- Diving category link -->
          @for (cat of allCategories; track cat.id) {
            @if ((cat.title || "").trim().toLowerCase() === "diving") {
              <a
                [routerLink]="['/tour']"
                [queryParams]="{ type: cat.id }"
                class="nav-link px-2 mx-2 fw-medium text-dark position-relative"
                routerLinkActive="active"
              >
                {{ cat.title }}
              </a>
            }
          }

          <!-- Destinations dropdown -->
          <ng-container *ngIf="allDestinations.length">
            <div
              class="nav-link px-2 mx-2 fw-medium text-dark position-relative dropdown custom-dropdown"
            >
              <span routerLink="/destination" class="d-block cPointer"
                >Destinations</span
              >
              <ul class="dropdown-menu border-0 shadow">
                <li *ngFor="let dest of allDestinations">
                  <a
                    class="dropdown-item"
                    [routerLink]="['/destination', dest.slug]"
                  >
                    {{ dest.title }}
                  </a>
                </li>
              </ul>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div class="offcanvas-footer border-top p-3">
    <button
      class="mainBtn Btn w-100 d-flex align-items-center justify-content-center gap-2"
    >
      Make trip
      <i
        class="fas fa-map-marker-alt fa-rotate-by textMainColor bgPrimaryWhiteColor rounded-circle overflow-hidden"
      ></i>
    </button>
  </div>
</div>

<!-- Backdrop -->
<!-- <div
  class="offcanvas-backdrop fade"
  [class.show]="isSidebarOpen"
  (click)="closeSidebar()"
  [style.display]="isSidebarOpen ? 'block' : 'none'"
></div> -->
